import React, { Suspense } from "react";

const WhatsAppLogs = React.lazy(() => import("@/pages/whatsapp-logs"));

export default function WhatsAppLogsContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <WhatsAppLogs />
    </Suspense>
  );
}
